export const duration = '10000ms';
import Color from 'color';
import { ColorPalette } from './types';

export const DEFAULT_COLORS: ColorPalette = {
  A: Color('#5135FF'),
  B: Color('#FF5828'),
  C: Color('#F69CFF'),
  D: Color('#FFA50F'),
};
